import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card-body" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "d-inline-block position-absolute h-4px top-0 end-0 start-0 bg-primary translate rounded" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "ms-n5 pb-2 fs-5" }, "Transactions", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "separator ms-n5 m-0" }, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "d-flex fs-6 fw-semibold align-items-center my-4 mb-0"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "bullet bg-muted me-3",
  style: {"border-radius":"3px","width":"12px","height":"12px"}
}, null, -1)
const _hoisted_7 = { class: "fs-7 fw-bold text-gray-600 me-5" }
const _hoisted_8 = { class: "ms-auto fw-bolder text-dark-700 text-end fs-7" }
const _hoisted_9 = { class: "ms-2 fs-8 fw-light text-dark text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([[_ctx.widgetClasses, `bg-light-${_ctx.color}`], "card"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.responseTotal, (response, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "col-12 px-0",
          key: index
        }, [
          (response.action_type != 'settle')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, _toDisplayString(response.action_type) + ": ", 1),
                _createElementVNode("div", _hoisted_8, [
                  _createTextVNode(_toDisplayString(response.count), 1),
                  _createElementVNode("span", _hoisted_9, " ($" + _toDisplayString(response.amount) + ")", 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ], 2))
}